import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import EmptyPoolStorageGenerationMain from "presentation/view/container/EmptyPoolStorageGeneration/EmptyPoolStorageGenerationMain";

CommonEntrypoint(<EmptyPoolStorageGenerationMain/>)